import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IViewComponent} from '../../../../../interface/panels';
import {IFormItems} from '../../../../../interface/form-structure';
import {NoosFormTypeService} from '../../../../../class/NoosFormTypeService';

@Component({
    selector: 'noos-view-container-tab',
    templateUrl: './view-container-tab.component.html',
    styleUrls: ['./view-container-tab.component.scss']
})
@NoosFormTypeService.register('ViewVIEWtab')
export class ViewContainerTabComponent implements OnInit, IViewComponent, AfterViewInit {


    formJson: IFormItems[];
    isFilter: boolean;

    @Output()
    keyOnEnter = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    constructor() {
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {

    }

    onEnterEvent($event: any) {
        this.keyOnEnter.emit();
    }


}

